<script lang="ts">
	import coffee2xl from "@assets/images/coffee.jpg?webp&imagetools";
	import coffeeXs from "@assets/images/coffee.jpg?webp&w=640&imagetools";
	import coffeeMd from "@assets/images/coffee.jpg?webp&w=1024&imagetools";
	import coffeeXl from "@assets/images/coffee.jpg?webp&w=1440&imagetools";
	import BuildYourSubscriptionButton from "@components/BuildYourSubscriptionButton.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import bagIcon from "@core/assets/icons/bag.svg?raw";
	import calendarIcon from "@core/assets/icons/calendar.svg?raw";
	import beanIcon from "@core/assets/icons/cofee-bean.svg?raw";
	import coinIcon from "@core/assets/icons/coin.svg?raw";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import translations from "./FathersClubPricingSection.translations.json" with { type: "json" };
	import FathersClubSavingsStats from "./FathersClubSavingsStats.svelte";

	const translate = getTranslate(translations);
	const { priceRange }: { priceRange: string } = $props();

	const parameters = [
		{ icon: beanIcon, text: translate("parameterVariant") },
		{ icon: calendarIcon, text: translate("parameterFrequency") },
		{ icon: bagIcon, text: translate("parameterSize") },
		{ icon: coinIcon, text: translate("parameterPayment") },
	];
</script>

<section class="full-width grid-container relative overflow-hidden py-12 sm:py-14 xl:py-16 2xl:py-20">
	<Media
		source={{ type: "image/webp", src: coffeeXs }}
		sourcesets={{ ">md": coffeeMd, ">xl": coffeeXl, ">2xl": coffee2xl }}
		width={1440}
		height={960}
		alt=""
		class="size-full object-cover"
		wrapperClass="absolute inset-0 full-width"
	/>
	<div class="absolute inset-0 bg-black/40 full-width"></div>
	<div
		class="relative z-10 bg-fcrbeige w-full p-8 gap-8 sm:p-10 xl:p-12 lg:items-center lg:min-h-107 flex flex-col lg:flex-row"
	>
		<div class="flex-1 flex uppercase flex-col gap-5">
			<div class="text-fcrorange font-bold tracking-[.1em] text-sm">
				<Formatted text={translate("caption")} />
			</div>
			<Heading level={2} text={translate("title")} class="font-antipol font-medium text-8/tighter text-fcrdarkgray" />
			<div class="normal-case tracking-normal flex flex-col gap-4 text-fcrdarkgray">
				<p class="font-antipol font-medium text-6/tighter">
					<Formatted text={translate("priceRange", { range: priceRange })} />
				</p>
				<p class="text-sm/tight font-light">
					<Formatted text={translate("priceNote")} />
				</p>
				<ul class="grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm/tight font-normal max-w-120">
					{#each parameters as parameter (parameter.text)}
						<li class="flex items-center gap-3">
							<Icon icon={parameter.icon} class="size-6 shrink-0 text-fcrbrown" aria-hidden="true" />
							<Formatted text={parameter.text} />
						</li>
					{/each}
				</ul>
			</div>
			<BuildYourSubscriptionButton variant={ButtonVariant.Dark} class="w-fit mt-2" registerLabel />
		</div>
		<div class="flex-1 flex flex-col gap-4">
			<p class="text-sm font-bold uppercase tracking-[.16em] text-fcrdarkgray">
				<Formatted text={translate("subtitle")} />
			</p>
			<FathersClubSavingsStats />
		</div>
	</div>
</section>
